
export default class Header {

	static getHolderSelectors = () => ['header'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#applySticky();
		this.#setMobileMenu();

		document.querySelectorAll('a[href^="tel:"]').forEach(element => {
			element.href = element.href.replaceAll(/[\s()]/g, '').replaceAll(/ /g, '').replaceAll(/(\s)/g, '').replaceAll(/-/g, '');
		});

		if (localStorage.getItem('fontSize')) {
			document.querySelector('html').style.fontSize = localStorage.getItem("fontSize");
		} else {
			document.querySelector('html').style.fontSize = '16px';
		}

		document.querySelectorAll('header, .tool-bar-element').forEach(element => {
			element.querySelector('.minus').addEventListener('click', (event) => {
				if (localStorage.getItem('fontSize') === null || localStorage.getItem('fontSize') === '16px') {
					localStorage.setItem('fontSize', '14px');
				} else if (localStorage.getItem('fontSize') === '18px')  {
					localStorage.setItem('fontSize', '16px');
				}
				document.querySelector('html').style.fontSize = localStorage.getItem("fontSize");
			});

			element.querySelector('.plus').addEventListener('click', (event) => {
				if (localStorage.getItem('fontSize') === null || localStorage.getItem('fontSize') === '16px') {
					localStorage.setItem('fontSize', '18px');
				} else if (localStorage.getItem('fontSize') === '14px')  {
					localStorage.setItem('fontSize', '16px');
				}
				document.querySelector('html').style.fontSize = localStorage.getItem("fontSize");
			});
		});
	}

	#applySticky() {
		let self = this;
		const toolBarElement = document.querySelector('.tool-bar-element');
		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver(function (entries) {
				if (entries[0].isIntersecting) {
					self.#holderElement.classList.remove('scrolled');
					toolBarElement.classList.remove('scrolled');
				} else {
					self.#holderElement.classList.add('scrolled');
					toolBarElement.classList.add('scrolled');
				}
			});
			if (toolBarElement) {
				observer.observe(toolBarElement);
			} else {
				this.#holderElement.classList.add('scrolled');
				toolBarElement.classList.add('scrolled');
			}
		}
	}

	#setMobileMenu() {
		let btnMenu = this.#holderElement.querySelector('.btn-menu');
		btnMenu.addEventListener('click', (event) => {
			btnMenu.innerHTML = btnMenu.innerHTML === 'Menu' ? 'Close' : 'Menu';
			document.querySelector('html').style.overflowY = btnMenu.innerHTML === 'Menu' ? 'unset' : 'hidden';
			document.querySelector('body').style.overflowY = btnMenu.innerHTML === 'Menu' ? 'unset' : 'hidden';
			this.#holderElement.querySelector('.header-menu.mobile-view').style.opacity = btnMenu.innerHTML === 'Menu' ? 0 : 1;
			this.#holderElement.querySelector('.header-menu.mobile-view').style.zIndex = btnMenu.innerHTML === 'Menu' ? -1 : 9;
			this.#holderElement.querySelector('.header-menu.mobile-view').style.visibility = btnMenu.innerHTML === 'Menu' ? 'hidden' : 'visible';
		});
	}

}
